import ViewPaginationComponent from './ViewPaginationComponent';
export default ViewPaginationComponent;
